import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Routes, RouterModule} from '@angular/router';

import {AppComponent} from 'src/app/app.component';

import {
  KeyPairListComponent,
  KeyPairDetailComponent,
  KeyPairCreateComponent,
  InstanceConsoleComponent,
  StatusListComponent,

  CloudListComponent,
  CloudDetailComponent,
  PoolOverviewComponent,
  PoolListComponent,
  PoolDetailComponent,
  InstanceListComponent,
  InstanceDetailComponent,
  InstanceLaunchComponent,
  InstanceWizardComponent,
  ImageListComponent,
  ImageCreateComponent,
  ImageDetailComponent,
  LoadBalancerListComponent,
  LoadBalancerDetailComponent,
  SecurityGroupListComponent,
  SecurityGroupDetailComponent,
  VolumeListComponent,
  VolumeDetailComponent,
  SnapshotListComponent,
  SnapshotDetailComponent,
  NetworkAddressListComponent,
  NetworkAddressDetailComponent,
  CatalogListComponent,
  CatalogDetailComponent,
  CatalogImageComponent,
  CatalogComputeComponent,
  CatalogSecurityGroupComponent,
  CatalogInstanceDetailComponent,
  CatalogInstanceWizardComponent,
  HistoryListComponent,
  HistoryDetailComponent,
  NetworkListComponent,
  NetworkDetailComponent,
  StatusOrderComponent,
  HostListComponent,
  HostDetailComponent,
  ResourceAuthService,
  NetworkSubnetDetailComponent
} from '@serengeti/serengeti-resource';

const routes: Routes = [
  {path: 'resource/instance/console/:id', component: InstanceConsoleComponent, pathMatch: 'full'},
  {
    path: 'main', component: AppComponent, canActivate: [ResourceAuthService], children: [
      {
        path: 'resource/keypair/list',
        component: KeyPairListComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.keypair.list.title', root: true}
      },
      {
        path: 'resource/keypair/create',
        component: KeyPairCreateComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.keypair.detail.title'}
      },
      {
        path: 'resource/keypair/detail/:id/',
        component: KeyPairDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.keypair.create.title'}
      },

      {
        path: 'resource/status/list',
        component: StatusListComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.status.list.title', root: true}
      },
      {
        path: 'resource/order/list',
        component: StatusOrderComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.status.order.title', root: true}
      },
      {
        path: 'resource/cloud/list',
        component: CloudListComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.cloud.list.title', root: true}
      },
      {
        path: 'resource/cloud/detail/:id/',
        component: CloudDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.cloud.detail.title'}
      },
      {
        path: 'resource/cloud/create',
        component: CloudDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.cloud.create.title'}
      },
      {
        path: 'resource/pool/list',
        component: PoolOverviewComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.pool.list.title', root: true}
      },
      // { path: 'resource/pool/list', component: PoolListComponent, outlet: 'content', canActivate: [ResourceAuthService],
      // data: { title: 'resource.pool.list.title', root: true }  },
      {
        path: 'resource/pool/detail/:id/',
        component: PoolDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.pool.detail.title'}
      },
      {
        path: 'resource/pool/create',
        component: PoolDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.pool.create.title'}
      },
      {
        path: 'resource/host/list', component: HostListComponent, outlet: 'content', canActivate: [ResourceAuthService],
        data: {title: 'resource.host.list.title', root: true}
      },
      {
        path: 'resource/host/detail/:id/',
        component: HostDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.host.detail.title'}
      },
      {
        path: 'resource/instance/list',
        component: InstanceListComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.instance.list.title', root: true}
      },
      {
        path: 'resource/instance/launch',
        component: InstanceWizardComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.instance.launch.title'}
      },
      {
        path: 'resource/instance/detail/:id/',
        component: InstanceDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.instance.detail.title'}
      },
      {
        path: 'resource/instance/launch/:id/',
        component: InstanceWizardComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.instance.detail.launch.title'}
      },
      {
        path: 'resource/image/list',
        component: ImageListComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.image.list.title', root: true}
      },
      {
        path: 'resource/image/create',
        component: ImageCreateComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.image.create.title'}
      },
      {
        path: 'resource/image/detail/:id/',
        component: ImageDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.image.update.title'}
      },
      {
        path: 'resource/loadbalancer/list',
        component: LoadBalancerListComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.loadbalancer.list.title', root: true}
      },
      {
        path: 'resource/loadbalancer/create',
        component: LoadBalancerDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.loadbalancer.create.title'}
      },
      {
        path: 'resource/loadbalancer/detail/:id/',
        component: LoadBalancerDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.loadbalancer.detail.title'}
      },
      {
        path: 'resource/securitygroup/list',
        component: SecurityGroupListComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.security-group.list.title', root: true}
      },
      {
        path: 'resource/securitygroup/create',
        component: SecurityGroupDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.security-group.create.title'}
      },
      {
        path: 'resource/securitygroup/detail/:id/',
        component: SecurityGroupDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.security-group.detail.title'}
      },
      {
        path: 'resource/volume/list',
        component: VolumeListComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.volume.list.title', root: true}
      },
      {
        path: 'resource/volume/detail/:id/',
        component: VolumeDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.volume.detail.title'}
      },
      {
        path: 'resource/snapshot/list',
        component: SnapshotListComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.snapshot.list.title', root: true}
      },
      {
        path: 'resource/snapshot/detail/:id/',
        component: SnapshotDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.snapshot.list.title', root: true}
      },
      {
        path: 'resource/publicIp/list',
        component: NetworkAddressListComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.public-ip.list.title', root: true}
      },
      {
        path: 'resource/publicIp/detail/:id/',
        component: NetworkAddressDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.public-ip.detail.title'}
      },
      {
        path: 'resource/network/list',
        component: NetworkListComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.network.list.title', root: true}
      },
      {
        path: 'resource/network/detail/:id/',
        component: NetworkDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.public-ip.detail.title'}
      },
      {
        path: 'resource/subnet/create', component: NetworkSubnetDetailComponent, outlet: 'content', canActivate: [],
        data: {title: 'resource.subnet.create.title'}
      },
      {
        path: 'resource/subnet/detail/:id/',
        component: NetworkSubnetDetailComponent,
        outlet: 'content',
        canActivate: [],
        data: {title: 'resource.subnet.detail.title'}
      },
      {
        path: 'resource/catalog/list',
        component: CatalogListComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.catalog.list.title', root: true}
      },
      {
        path: 'resource/catalog/detail/:id/',
        component: CatalogDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.catalog.detail.title'}
      },
      {
        path: 'resource/catalog/instance/detail/:instanceId/',
        component: CatalogInstanceDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.catalog.instance.title'}
      },
      {
        path: 'resource/catalog/create',
        component: CatalogDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'resource.catalog.create.title'}
      },
      {
        path: 'resource/catalog/wizard', component: CatalogInstanceWizardComponent, outlet: 'content', canActivate: [],
        data: {title: 'resource.catalog.wizard.title'}
      },
      {
        path: 'resource/catalog/compute/list',
        component: CatalogComputeComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService]
      },
      {
        path: 'resource/catalog/image/list',
        component: CatalogImageComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService]
      },
      {
        path: 'resource/catalog/securityGroup/list',
        component: CatalogSecurityGroupComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService]
      },
      {
        path: 'resource/history/list',
        component: HistoryListComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'notification.list.title', root: true}
      },
      {
        path: 'resource/history/:id/',
        component: HistoryDetailComponent,
        outlet: 'content',
        canActivate: [ResourceAuthService],
        data: {title: 'notification.detail.title'}
      },
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload', useHash: true}),
    CommonModule
  ],
  exports: []
})
export class AppRoutingResourceModule {
}
